import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "revico-community-talk-post--nickname" }
const _hoisted_2 = {
  key: 0,
  class: "revico-community-talk-post--nickname-error-message"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode($setup["CustomLabel"], {
      text: `ニックネーム ${$setup.isRequiredNickname ? '(必須)' : ''}`,
      disabled: $props.disabled
    }, null, 8 /* PROPS */, ["text", "disabled"]),
    _createVNode($setup["CustomInput"], {
      modelValue: $setup.inputNickName,
      "onUpdate:modelValue": [
        _cache[0] || (_cache[0] = ($event: any) => ($setup.inputNickName = $event)),
        _cache[1] || (_cache[1] = ($event: any) => ($setup.onChange()))
      ],
      name: $setup.name,
      type: "text",
      customClass: "revico-community-talk-post--nickname-input",
      "api-validation-error-view-model": $props.showRequiredError ? null : $props.apiValidationErrorViewModel,
      maxlength: $setup.nickNameMaxLength,
      disabled: $props.disabled
    }, null, 8 /* PROPS */, ["modelValue", "name", "api-validation-error-view-model", "maxlength", "disabled"]),
    ($props.showRequiredError)
      ? (_openBlock(), _createElementBlock("span", _hoisted_2, "ニックネームを入力してください。"))
      : _createCommentVNode("v-if", true)
  ]))
}